import styled from 'styled-components';

export const DropdownContainer = styled.div`
  width: 100%;
  text-align: left;
  position: relative;
`;

export const DropdownStyled = styled.div<{ isValid?: boolean; value: string }>`
  width: 100%;
  height: 40px;
  border: 1px solid #ad9552;
  border-radius: 2px;
  color: #0c0c0c;
  box-sizing: border-box;
  padding: 10.5px 42px 10.5px 8px;
  margin-top: 4px;
  font-size: 16px;
  position: relative;

  ${props =>
    !props.value &&
    `
      color: #8f8f8f;
  `}
`;

export const HelperText = styled.div`
  margin-top: 8px;
`;

export const DropdownOptionsContainer = styled.div<{ open: boolean }>`
  position: absolute;
  top: 70px;
  width: 100%;
  background-color: #ffffff;
  border: 1px solid #ad9552;
  opacity: ${props => (props.open ? 1 : 0)};
  visibility: ${props => (props.open ? 'visible' : 'hidden')};
  transition:
    opacity 300ms,
    visibility 300ms;
`;

export const DropdownOption = styled.div`
  width: 100%;
  height: 56px;
  align-content: center;
  padding: 0 16px;
`;

export const DropdownIcon = styled.img`
  width: 12px;
  height: 12px;
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
`;
